import { DeployCountry } from "@types";

/**
 * Phone config (local-only rules)
 * - startWith: Allowed starting masks for local numbers. Supports wildcards: '*' matches a digit.
 * - additionalLengths: Additional local total-digit lengths (legacy multi-length only, e.g., +62)
 * - simpleError: Simplify validator messages to "Enter a {{length}} digit number" when single-length
 * - noLeadingZero: If true, member settings will NOT add +1 to server lengths
 */
type PhoneConfig = {
  startWith: string[];
  additionalLengths?: number[];
  simpleError?: boolean;
  noLeadingZero?: boolean;
  displayInputPrefix?: boolean;
};

export const COUNTRY_CODE = {
  [DeployCountry.ID]: "+62",
  [DeployCountry.IN]: "+91",
  [DeployCountry.MX]: "+52",
  [DeployCountry.BR]: "+55",
  [DeployCountry.TH]: "+66",
  [DeployCountry.PH]: "+63",
} as const;

export const PHONE_CONFIGS: Record<string, PhoneConfig> = {
  // Indonesia (legacy local starts with 0)
  ["+62"]: {
    startWith: ["0"],
    additionalLengths: [10], // old format, BE didn't send old length
  },
  // India (INR) local starts with 6/7/8/9
  ["+91"]: {
    startWith: ["6", "7", "8", "9"],
    simpleError: true,
    noLeadingZero: true,
    displayInputPrefix: true,
  },
  // Mexico (MXN) local starts with 55/56/33/81
  ["+52"]: {
    startWith: [],
    simpleError: true,
    noLeadingZero: true,
    displayInputPrefix: true,
  },
  // Brazil (BRL) local: 2-digit DDD + 9-digit mobile=> mask "**9"
  ["+55"]: {
    startWith: ["**9"],
    simpleError: true,
    noLeadingZero: true,
    displayInputPrefix: true,
  },
} as const;

// Other countries required 0
export const DEFAULT_PHONE_CONFIG: PhoneConfig = {
  startWith: ["0"],
} as const;
